export const SUPPORT_CONTENT_FIELDS = {
  terms: 'termsContent',
  privacy: 'privacyContent',
  dataAuth: 'dataAuthContent',
  faq: 'faqContent',
  about: 'aboutUsContent',
};

export const DEFAULT_SIC_LOGO_URL =
  'https://www.sic.gov.co/style%20library/images/logo.png';

export const DEFAULT_SIC_WEBSITE_URL = 'https://www.sic.gov.co';

export function buildDefaultSupportMenu(settings = {}) {
  const brand = settings.appName || settings.CompanyName || 'Movex';
  const chatUrl = settings.supportChatUrl || settings.WhatsAppLink || '';
  return [
    { id: 'faq', label: 'Preguntas frecuentes', action: 'content', value: 'faq', enabled: true },
    { id: 'chat', label: 'Chatea con nosotros', action: 'url', value: chatUrl, enabled: true },
    { id: 'call', label: 'Habla con nosotros', action: 'phone', value: settings.CompanyPhone || '', enabled: true },
    { id: 'pqr', label: 'Envíanos una PQR', action: 'screen', value: 'Complain', enabled: true },
    { id: 'about', label: `Conoce ${brand}`, action: 'screen', value: 'About', enabled: true },
    { id: 'terms', label: `Términos y Condiciones ${brand}`, action: 'content', value: 'terms', enabled: true },
    { id: 'privacy', label: `Política de tratamiento de información ${brand}`, action: 'content', value: 'privacy', enabled: true },
    { id: 'data_auth', label: `Autorización Tratamiento de Datos ${brand}`, action: 'content', value: 'dataAuth', enabled: true },
  ];
}

export function normalizeSupportMenuItems(items) {
  if (!Array.isArray(items)) return [];
  return items
    .filter((item) => item && typeof item === 'object')
    .map((item) => ({
      id: String(item.id || ''),
      label: String(item.label || ''),
      action: String(item.action || 'url'),
      value: item.value != null ? String(item.value) : '',
      enabled: item.enabled !== false,
    }))
    .filter((item) => item.id && item.label);
}

export function getSupportMenuItems(settings) {
  const custom = normalizeSupportMenuItems(settings?.supportMenuItems);
  if (custom.length > 0) {
    return custom.filter((item) => item.enabled);
  }
  return buildDefaultSupportMenu(settings || {}).filter((item) => item.enabled);
}

export function getLegalContentField(contentKey) {
  return SUPPORT_CONTENT_FIELDS[contentKey] || null;
}

import { buildLegalContentFallback } from './legalContentDefaults';

export function getLegalContent(settings, contentKey, translate) {
  const field = getLegalContentField(contentKey);
  const stored = field && settings?.[field] ? String(settings[field]).trim() : '';
  if (stored) {
    return settings[field];
  }
  if (translate) {
    const fallback = buildLegalContentFallback(contentKey, translate, settings || {});
    if (fallback?.trim()) {
      return fallback;
    }
  }
  return '';
}
